import { useState, useEffect } from "react";
import {
  setProgressBarLoaderPopupValue,
  toggleProgressBarLoaderPopupVisible,
} from "../common_widgets/progress-load-indicator/component";
import { GET_DOCUMENT_OCR_STATUS } from "./services/get-document-ocr-status";
import {
  OCRJobStatus,
  RESET_OCR_STATUS,
  SET_S3_OBJECT_NAME,
  ocrPollingData,
} from "./reducers/case-search-reducer";
import { CASE_SEARCH_CRITERIA_POPUP_MODE, toggleCaseSearchCriteriaListPopupVisible } from "./case-search-list-popup";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../common_widgets/toast/notify";
import { useDispatch, useSelector } from "react-redux";
import { isEqual } from "lodash";
export const stopOCRPolling = (dispatch) => {
  clearInterval(ocrPollingIntervalId);
  toggleProgressBarLoaderPopupVisible(dispatch, false);
};

let ocrPollingIntervalId = null;
const ocrPollingRateMillisecnds = 1000;
export const OCR_PAGE_LOCATION = {
  AUDIT: "AUDIT",
  AUDIT_CREATE: "AUDIT_CREATE",
  CASE_SEARCH_PAGE: "CASE_SEARCH_PAGE",
};

export const initiateOCRPolling = (
  dispatch,
  asyncAction,
  data = ocrPollingData
) => {
  dispatch({
      type: SET_S3_OBJECT_NAME,
      data: data.s3ObjectName,
  });
  if (ocrPollingIntervalId != null) clearInterval(ocrPollingIntervalId);
  ocrPollingIntervalId = setInterval(() => {
    asyncAction.asyncOperationStart(GET_DOCUMENT_OCR_STATUS, data.s3ObjectName);
  }, ocrPollingRateMillisecnds);

  toggleProgressBarLoaderPopupVisible(
    dispatch,
    true,
    "Thinking",
    true,
  );
};
const useOCRPolling = (location = OCR_PAGE_LOCATION.AUDIT) => {
  const dispatch = useDispatch();
  const ocrJobStatus: OCRJobStatus = useSelector(
    (state) => state["caseSearchReducer"].ocrJobStatus,
    isEqual
  );
  const isFromSingleCaseSearch = location == OCR_PAGE_LOCATION.CASE_SEARCH_PAGE;
  const isFromAuditCreate = location == OCR_PAGE_LOCATION.AUDIT_CREATE;

  useEffect(() =>{
    setProgressBarLoaderPopupValue(dispatch, ocrJobStatus.complete_percentage);
  }, [ocrJobStatus.complete_percentage])

  useEffect(() => {
    switch (ocrJobStatus.run_status) {
      case "STARTED":
        if(!ocrJobStatus.complete_percentage){
          setProgressBarLoaderPopupValue(dispatch, 10);
        }
        break;
      case "INPROGRESS":
        if(!ocrJobStatus.complete_percentage){
          setProgressBarLoaderPopupValue(dispatch, 50);
        }
        break;
      case "SUCCESS":
        if (ocrJobStatus.complete_percentage && ocrJobStatus.complete_percentage < 100) {
          break;
        }
        if(!ocrJobStatus.complete_percentage){
          setProgressBarLoaderPopupValue(dispatch, 100);
        }
        stopOCRPolling(dispatch);
        if(!isFromSingleCaseSearch && !isFromAuditCreate)
        {
          toggleCaseSearchCriteriaListPopupVisible(
          dispatch,
          true,
          null,
          CASE_SEARCH_CRITERIA_POPUP_MODE.OCR_VALIDATION,);
        }
        break;
      case "FAILED":
        setProgressBarLoaderPopupValue(dispatch, 100);
        stopOCRPolling(dispatch);
        mdaeNotify({
          message: ocrJobStatus.current_step,
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
        dispatch({
          type: RESET_OCR_STATUS,
        });
        break;

      default:
        if(ocrJobStatus.run_status != "INPROGRESS")
          setProgressBarLoaderPopupValue(dispatch, 0);
        break;
    }

  }, [ocrJobStatus.run_status, ocrJobStatus.complete_percentage]);
};

export default useOCRPolling;
